// TODO remove this entire module and merge the logic into the other date filter
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import moment from 'moment';
import 'classlist-polyfill';
import 'react-datepicker/dist/react-datepicker.css';
import './DateFilter.less';


class DateFilter extends Component {
  static propTypes = {
    name: PropTypes.string,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func,
    from: PropTypes.object,
    to: PropTypes.object,
    className: PropTypes.string,
  };

  static defaultProps = {
    name: '',
    onChangeFrom: () => {
    },
    onChangeTo: () => {
    },
    from: moment(),
    to: moment(),
    className: '',
  };

  render() {
    const {
      onChangeFrom,
      onChangeTo,
      from,
      to,
      name,
      className,
    } = this.props;

    return (
      <div className={`date-picker-parent-container ${className}`}>
        <div className="date-picker-container">
          <label className="date-picker-label">Date{name ? ` ${name}` : ''} from</label>
          <DatePicker
            selected={moment(from)}
            onChange={onChangeFrom}
            dateFormat="MM/DD/YYYY"
            className="date-picker" />
        </div>
        <div className="date-picker-container">
          <label className="date-picker-label">Date{name ? ` ${name}` : ''} to</label>
          <DatePicker
            selected={moment(to)}
            onChange={onChangeTo}
            dateFormat="MM/DD/YYYY"
            minDate={moment(from)}
            maxDate={moment(from).add(30, 'days')}
            className="date-picker" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  validationErrorsFields: state.getIn(['validationErrors', 'fields'], []),
});

export default connect(mapStateToProps)(DateFilter);



/** WEBPACK FOOTER **
 ** ./src/components/Modules/DateFilter/DateFilter.js
 **/